import { Code } from '../generated/codes-app-api'

export const municipalityCodes = [] as Code[]
